import { render, staticRenderFns } from "./RecentApplicationsListTable.vue?vue&type=template&id=678a9cee&"
import script from "./RecentApplicationsListTable.vue?vue&type=script&lang=js&"
export * from "./RecentApplicationsListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports